import { Link } from "react-router-dom";

import { makeStyles } from "@material-ui/core";
import CancelCircleIcon from "@material-ui/icons/Cancel";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

import FormikTextField from "src/components/form/FormikTextField";
import { getCampaign_campaign } from "src/graphql/generated/getCampaign";
import { CalleeField } from "src/graphql/generated/globalTypes";
import palette from "src/styles/palette";

const PREFILL_CONTACT_FIELDS: CalleeField[] = [
  CalleeField.FIRST_NAME,
  CalleeField.LAST_NAME,
  CalleeField.EMAIL,
  CalleeField.ZIP
];

const useStyles = makeStyles(theme => ({
  fieldName: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  },
  fieldLabel: {
    paddingLeft: "5px"
  },
  fieldList: {
    marginBottom: theme.spacing(4)
  }
}));

const MappedIcon = () => <CheckCircleIcon htmlColor={palette.green} />;
const UnmappedIcon = () => <CancelCircleIcon htmlColor={palette.darkGray} />;

function Field({ mapped, name }: { mapped: boolean; name: string }) {
  const classes = useStyles();
  return (
    <div className={classes.fieldName}>
      {mapped ? <MappedIcon /> : <UnmappedIcon />}
      <div className={classes.fieldLabel}>{name}</div>
    </div>
  );
}

export default function MobilizeAmericaRSVPSettings({
  eventUrlFieldName,
  campaign
}: {
  eventUrlFieldName: string;
  campaign: getCampaign_campaign;
}): JSX.Element {
  const classes = useStyles();

  return (
    <div>
      <FormikTextField
        fullWidth
        label="MobilizeAmerica Event URL"
        placeholder="https://www.mobilize.us/mobilize/event/123/"
        name={eventUrlFieldName}
      />

      <div className={classes.fieldList}>
        <div>
          The RSVP form will be pre-filled based on your campaign's{" "}
          <Link to="contacts">mapped contact fields</Link>:
        </div>
        <div>
          <Field name="Phone" mapped />
          {PREFILL_CONTACT_FIELDS.map(builtInFieldId => {
            const field = campaign.calleeFields.find(
              field => field.builtInField === builtInFieldId
            );
            if (!field) {
              return null;
            }

            return (
              <Field
                name={field.name}
                mapped={!!field.dataSourceFieldName}
                key={builtInFieldId}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}
